import React from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from 'layouts/supporter/Layout';
import SubmitButton from 'components/SubmitButton';
import { IconChevronLeft, IconClose } from 'components/Svg';

const RescueReport: React.FC = () => {
  const navigate = useNavigate();

  const handleSubmit = () => {
    // submit logic
    alert('送信しました');
  };

  return (
    <Layout>
      <div className="p-4">
        {/* Header: 最上位階層のみtitleとicon */}
        <div className="flex items-center justify-between">
          <button className="p-2" onClick={() => navigate(-1)}>
            <IconChevronLeft />
          </button>
          <div className="flex flex-col items-center flex-1">
            <span className="text-lg font-medium text-gray-900">レスキュー作業報告</span>
          </div>
          <button className="p-2" onClick={() => navigate('/supporter')}>
            <IconClose />
          </button>
        </div>

        {/* Content */}
        <main className="flex-1 px-4 py-2 overflow-auto">
          {/* Form fields */}
          <div className="space-y-4 text-sm text-gray-800">
            <div className="mb-2 text-base font-semibold text-gray-700">レスキュー案件番号検索</div>
            <div>
              <label className="block mb-1 text-gray-500">レスキュー案件番号</label>
              <input type="text" value="" className="w-full p-2 bg-white border border-gray-300 rounded-lg"/>
            </div>
          </div>
        </main>

        <div className="px-4 py-6 shadow-top">
          <div className="flex flex-col items-center mb-2 text-sm">
            <div className="flex justify-center w-1/5 space-x-4">
              <SubmitButton onClick={handleSubmit}>
                検索
              </SubmitButton>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default RescueReport;